/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';

/**
 * SelectYourFoundation Input Action
 */
export class SelectYourFoundationInput implements Msdyn365.IActionInput {
    public foundation: SimpleProduct | undefined | null;
    //   Construct the input needed to run the action
    constructor(foundation: SimpleProduct | undefined | null) {
        this.foundation = foundation;
    }

    //   Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `SelectYourFoundation`;
    public getCacheObjectType = () => 'SelectYourFoundation';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}

//   Create a data model here or import one to capture the response of the action
export interface ISelectYourFoundationData {
    foundation: SimpleProduct | undefined | null;
}

/**
 *   Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext<ISelectYourFoundationData>): Msdyn365.IActionInput => {
    return new SelectYourFoundationInput(args?.config?.foundation);
};

/**
 *   Use this function to call your action and process the results as needed
 */
async function action(input: SelectYourFoundationInput, ctx: Msdyn365.IActionContext): Promise<ISelectYourFoundationData> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    //   Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<ISelectYourFoundationData[]>('/get/example/id/1', 'get');
    return { foundation: input.foundation };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ISelectYourFoundationData>>action,
    //   Give your data action a unique id
    id: 'SelectYourFoundation',
    input: createInput
    //   Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
